import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NotificationDataService } from '../services/notification-data.service';
import { Store } from '@ngrx/store';
import { AuthState } from '../state/auth/auth.state';
import { AuthActions } from '../state/auth';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-banner',
  standalone: true,
  templateUrl: './notification-banner.component.html',
  styleUrl: './notification-banner.component.scss',
  imports: [
    CommonModule,
    NgIf,
    HttpClientModule
  ]
})
export class NotificationBannerComponent {

  movingText: string = '';
  showBanner: boolean = false;
  showBannerPasswordReset: boolean = false;

  constructor(
    private notificationDataService: NotificationDataService,
    private store: Store<AuthState>,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef
    ) {

  }

  ngOnInit(): void {

    this.notificationDataService.getBannerPasswordReset().subscribe((data: any) => {
      if (data.statuscode == 200 && data.data.length >= 1) {
        this.movingText = data.data[0].bannerText;
        this.showBanner = false;

        setTimeout(() => {
          this.showBannerPasswordReset = true;
          this.cdr.detectChanges();
        }, 1000);
      }
      else {
        this.showBannerPasswordReset = false;
        this.getBannerText();
      }

    },
      error => {
        this.showBannerPasswordReset = false;
        this.getBannerText();
      }
    );

  }

  login(url: string) {
    this.store.dispatch(AuthActions.login());
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      if (isAuthenticated) {
        this.router.navigate([url]);
      }
    })
  }

  getBannerText() {

    this.notificationDataService.getBannerText().subscribe((data: any) => {
      if (data.statuscode == 200 && data.data.length >= 1) {
        this.movingText = data.data[0].bannerText;
        this.showBannerPasswordReset = false;

        setTimeout(() => {
         this.showBanner = true;
         this.cdr.detectChanges();
       }, 1000);
      }
      else {
        this.showBanner = false;
      }

    },
      error => {
        this.showBanner = false;
      }
    );

  }

  pauseMarquee() {
    const marqueeElement = document.querySelector('.marquee');
    if (marqueeElement) {
      marqueeElement.classList.add('paused');
    }
  }

  resumeMarquee() {
    const marqueeElement = document.querySelector('.marquee');
    if (marqueeElement) {
      marqueeElement.classList.remove('paused');
    }
  }

}
